const FLIXBUS_EU = "flixbuseur";
const BLABLACAR = "blablacar";
const POPARIDE = "poparide";
const VIARAIL = "viarail2";
const MOVELIA = "moveliaudm";

export const EU_INCLUDE_FEES_SOURCES = [FLIXBUS_EU];
export const CURATED_INVENTORY_SOURCES = [BLABLACAR, POPARIDE];
export const MERGE_FEES_SOURCES = [VIARAIL, MOVELIA];
